<template>
  <div>
    <Form
      ref="formDynamic"
      :model="formDynamic"
      :label-width="100"
      style="width: 1010px; margin-top: 20px"
    >
      <FormItem label="事由:" prop="name">
        <Input placeholder="请输入事由" v-model="shiyou"></Input>
      </FormItem>
      <FormItem label="期望交付日期:" prop="date">
        <DatePicker
          :options="options"
          type="date"
          placeholder="选择日期"
          v-model="jiaofuData"
        ></DatePicker>
      </FormItem>
      <FormItem label="收货信息:" prop="name">
        <Input
          v-model="shouhuoInfo"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 3 }"
        ></Input>
      </FormItem>
      <!-- 表格 -->
      <Row style="margin: 0 0 10px 100px">
        <Table
          :columns="tableCols"
          :data="data2"
          :table="table"
          :border="table.border"
          :stripe="table.stripe"
          :header="table.header"
          :footer="table.footer"
          :columns-list="tableCols"
        >
        </Table>
      </Row>
      <FormItem label="备注:" prop="name">
        <Input
          v-model="receiveOpinion"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 3 }"
        ></Input>
      </FormItem>
      <FormItem>
        <Row>
          <Col span="19">
            <Button type="primary" @click="handleSubmit()">提交</Button>
          </Col>
          <Col span="5">
            <h3 class="zong">总价:{{ zongjia }}元</h3></Col
          >
        </Row>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
import dayjs from "dayjs";
export default {
  props: {
    consumableInventory: [],
  },
  data() {
    return {
      zongjia: 0,
      receiveOpinion: "",
      options: {
        disabledDate: function (date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const checkDate = new Date(date);
          return checkDate < today;
        },
      },
      shiyou: "",
      jiaofuData: "",
      shouhuoInfo: "",
      table: {
        mname: "consumables",
        key: "id",
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      index: 1,
      desk: "",
      receive: "",
      data2: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 485,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
                }),
                h("div", [
                  h(
                    "p",
                    {
                      style: {
                        marginTop: "10px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      domProps: {
                        title: p.row.brand + p.row.name,
                      },
                    },
                    p.row.brand + p.row.name
                  ),
                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.model == null ? "none" : "block",
                      },
                      domProps: {
                        title: "型号:" + p.row.model,
                      },
                    },
                    "型  号: " + p.row.model
                  ),
                  h(
                    "p",
                    {
                      style: {
                        width: "350px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.remark == null ? "none" : "block",
                      },
                      domProps: {
                        title: "适用于: " + p.row.remark,
                      },
                    },
                    "适用于: " + p.row.remark
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "库存",
          key: "num",
          minWidth: 85,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "单价/元",
          key: "unitPrice",
          minWidth: 85,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unitPrice;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "采购数量",
          key: "alertNum",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return h(
              "InputNumber",
              {
                props: {
                  min: 1,
                  value: row.alertNum,
                },
                on: {
                  "on-change": (event) => {
                    this.data2[params.index].alertNum = event;
                    this.getzongjia(this.data2);
                  },
                },
                style: {
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              row.alertNum
            );
          },
        },
      ],
    };
  },
  async created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let arr = this.consumableInventory;
      for (let i = 0; i < arr.length; i++) {
        let consumableIn = {};
        let item = arr[i];
        consumableIn.inventoryId = item.inventoryId;
        consumableIn.consumableNum = item.consumableNum;
        consumableIn.consumableImgUrl = item.consumableImgUrl;
        consumableIn.brand = item.brand;
        consumableIn.name = item.name;
        consumableIn.model = item.model;
        consumableIn.remark = item.remark;
        consumableIn.unit = item.unit;
        consumableIn.alertNum = item.receiveNum ? item.receiveNum : 1;
        consumableIn.num = item.num;
        consumableIn.unitPrice = item.unitPrice == null ? 0 : item.unitPrice;
        consumableIn.consumableUuid = item.consumableUuid;
        this.data2.push(consumableIn);
      }
      this.getzongjia(this.data2);
    },
    getzongjia(list) {
      this.zongjia = list.reduce((accumulator, item) => {
        const num = Number(item.alertNum || 0);
        const price = Number(item.unitPrice || 0);
        return accumulator + price * num;
      }, 0);
      this.zongjia = this.zongjia.toFixed(2);
    },
    async handleSubmit() {
      let q = {
        sysProcurementDetails: this.data2,
        becauseWork: this.shiyou,
        needTime: dayjs(this.jiaofuData).format("YYYY-MM-DD"),
        receivingInformation: this.shouhuoInfo,
        totalPrice: this.zongjia,
        receiveOpinion: this.receiveOpinion,
      };
      let res = await $utils.api.load("/admin/system/procurementWork/add", q, "post");
      if (res.code == 200) {
        $utils.toast.success("提交成功");
        this.$Modal.remove();
        setTimeout(() => {
          $utils.url.go(0);
        }, 1000);
      } else {
        $utils.toast.error(res.message);
      }
    },
    handleRemove(index) {
      this.formDynamic.items[index].status = 0;
    },
  },
};
</script>
<style scoped>
.zong {
  color: black;
}
</style>
